import { onDomReady } from "../services/on-dom-ready";
import ModalBlocked from "../components/modal/modal-blocked";

const nativeConfirm = window.confirm.bind(window);

const confirmPopupPromise = new Promise((resolve, reject) => {
  onDomReady.then(() => {
    let element = document.getElementById("confirm");
    if (element) {
      let popup = ModalBlocked.get(element);
      resolve(popup);
    } else {
      reject("There is no #confirm element on page");
    }
  });
});

const confirm = (options = {}) => {
  if (typeof options === "string") {
    return nativeConfirm(options);
  }

  const { question, confirmText } = options;

  return new Promise((resolve, reject) => {
    confirmPopupPromise
      .then(popup => {
        let confirmButton = popup.root.querySelector('[data-confirm-button]');
        let confirmed = false;

        if (confirmText) {
          confirmButton.innerHTML = confirmText;
        }
        
        if (question) {
          let text = popup.root.querySelector('[data-confirm-question]');
          text.innerHTML = question;
        }

        const onSuccess = () => {
          confirmed = true;
          popup.close();
          resolve();
        }

        confirmButton.addEventListener('click', onSuccess);

        popup.root.addEventListener(ModalBlocked.events.closed, () => {
          if (!confirmed) reject();
          confirmButton.removeEventListener('click', onSuccess);
        }, { once: true });

        popup.open();
      })
      .catch(error => reject(error));
  })
}

export { confirm };
